import { Environment } from './environment.model';
import { APP_VERSION } from './version';

export const environment: Environment = {
  environment: 'stage',
  appVersion: APP_VERSION,
  amplitude: { apiKey: 'd843ea8fe6d51c3d8d8db1fc4acae7d8' },
  production: false,
  oktaClientId: '0oasir2mqpTBN8asa697',
  apiEndpoints: {
    'api-mobile': 'https://api-internal.stage.insidebrightside.com',
    copilot: 'https://copilot.stage.insidebrightside.com/api/v1',
  },
  sentry: {
    dsn: 'https://9afb809b96d96ce273e52f7997dc6a0a@o4505166779187200.ingest.us.sentry.io/4509713674272768',
    environment: 'stage',
  },
  storyServiceBaseUrl: 'https://story.stage.insidebrightside.com',
  storyDemoKey: 'a-random-demo-key-here',
  storyAdminKey: 'a-random-admin-key-here',
};
